import React, { useState } from 'react';
import './InputArea.css';

const InputArea = ({ onSendMessage, disabled }) => {
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('InputArea handleSubmit called', message, disabled);
    if (message.trim() && !disabled) {
      console.log('Calling onSendMessage with:', message.trim());
      onSendMessage(message.trim());
      setMessage('');
    } else {
      console.log('Message not sent - empty or disabled');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <div className="input-area">
      <form onSubmit={handleSubmit} className="input-form">
        <div className="input-container">
          <textarea
            type="text"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={disabled ? "Assistant is typing..." : "Type your response..."}
            disabled={disabled}
            className="message-input"
            rows="1"
          />
          <button 
            type="submit" 
            disabled={!message.trim() || disabled}
            className="send-button"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path 
                d="M22 2L11 13M22 2L15 22L11 13M22 2L2 9L11 13" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default InputArea;